// Map.js

import React, { useEffect } from "react";

function Map() {
  useEffect(() => {
    if (window.gtag && window.consented)
      window.gtag("event", "tool_view", { tool: "map" });
  }, []);
  const openMap = (address) => {
    const url = `https://maps.google.com/maps?q=${encodeURIComponent(address)}`;
    window.open(url, "_blank");
    if (window.gtag && window.consented)
      window.gtag("event", "map_click", { location: address });
  };

  return (
    <section className="utility canada-theme us-theme">
      <h2>Map</h2>
      <div className="map-buttons">
        <div className="canada">
          <button
            onClick={() => openMap("Windsor Tunnel, Windsor, ON, Canada")}
          >
            <strong>Tunnel</strong>
          </button>
          <button
            onClick={() => openMap("Ambassador Bridge, Windsor, ON, Canada")}
          >
            <strong>Bridge</strong>
          </button>
        </div>
        <div className="america">
          <button onClick={() => openMap("Windsor Tunnel, Detroit, MI, USA")}>
            <strong>Tunnel</strong>
          </button>
          <button
            onClick={() => openMap("Ambassador Bridge, Detroit, MI, USA")}
          >
            <strong>Bridge</strong>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Map;
